/* eslint-disable */
// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import "./styles.scss"

// Imgs
import negociacaoImg from '../../../../assets/negociacao.svg'
import finalizacaoImg from '../../../../assets/finalizacao.svg'
import mensagemImg from '../../../../assets/mensagem.svg'

const NotifyCard = ({ propostaId, status, subStatus, text, date, ...rest }) => {
  let content = null
  let to = '/'
  let img = null

  switch (status) {
    case 1:
      content = `Você possui um novo caso.`
      break
    case 2:
      if (subStatus === 1) {
        content = <p>O caso <span>{propostaId}</span> está aguardando proposta</p>
      }
      if (subStatus === 2) {
        content = <p>O caso <span>{propostaId}</span> recebeu uma nova mensagem</p>
      }
      break
    case 3:
      if (subStatus === 1) {
        content = <p>O caso <span>{propostaId}</span> está aguardando minuta</p>
      }
      if (subStatus === 2) {
        content = <p>O caso <span>{propostaId}</span> recebeu uma nova mensagem</p>
      }
      if (subStatus === 3) {
        content = <p>O caso <span>{propostaId}</span> recebeu uma minuta</p>
      }
      if (subStatus === 4) {
        content = <p>O caso <span>{propostaId}</span> está aguardando protocolo</p>
      }
      break
    default:
      content = 'Ocorreu alteração no seu caso'
  }

  let now = new Date()
  let createdAt = new Date(date);
  let diffMillisec = now.getTime() - createdAt.getTime()

  function timeConversion(millisec) {
    var seconds = (millisec / 1000).toFixed(0);
    var minutes = (millisec / (1000 * 60)).toFixed(0);
    var hours = (millisec / (1000 * 60 * 60)).toFixed(0);
    var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(0);

    if (seconds < 60) {
      return seconds + (seconds <= 1 ? " segundo" : " segundos")
    } else if (minutes < 60) {
      return minutes + (minutes <= 1 ? " minuto" : " minutos")
    } else if (hours < 24) {
      return hours + (hours <= 1 ? " hora" : " horas")
    } else {
      return days + (days <= 1 ? " dia" : " dias")
    }
  }

  let diffConverted = timeConversion(diffMillisec)

  return (
    <NavLink
      className={`notify-card notify-card--status-${status}`}
      to={`/meus-casos/${propostaId}`}
      {...rest}>
      <div className="notify-card__text">
        {content}
        <p className="notify-card__date">{diffConverted} atrás</p>
      </div>
    </NavLink>
  )
}

export default NotifyCard
